<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.1429 2.24121H7.31194H3.17664C1.97432 2.24121 0.999646 3.21588 0.999646 4.41821V10.5138C0.999646 11.7161 1.97432 12.6908 3.17664 12.6908H9.27223C10.4745 12.6908 11.4492 11.7161 11.4492 10.5138V6.32059" stroke="white" stroke-width="1.0885" stroke-linecap="round"/>
        <path d="M5.78906 7.90193L12.7554 0.935547" stroke="white" stroke-width="1.0885" stroke-linecap="round"/>
        <path d="M10.1434 0.935399H12.7558" stroke="white" stroke-width="1.0885" stroke-linecap="round"/>
        <path d="M12.7556 0.935547V3.54794" stroke="white" stroke-width="1.0885" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'open-consent-form-icon'
}
</script>